import mergeCapabilityPatch from '@/lib/settings/rolePermissions/mergeRoleCapabilityPatch.js';

const applyPendingUserCapabilityPatches = ({ capabilities, pendingMutations } = {}) => {
  return (Array.isArray(pendingMutations) ? pendingMutations : []).reduce((currentValue, pendingMutation) => {
    return mergeCapabilityPatch({
      currentValue,
      patchValue: pendingMutation?.capabilities || {}
    });
  }, capabilities || {});
};

export default applyPendingUserCapabilityPatches;
